import { useEffect, useRef } from "react";

export default function MailerLiteWidget({ formId = "jSUyFj", accountId = "2193986" }) {
  const containerRef = useRef(null);

  useEffect(() => {
    let timer = null;
    let attempts = 0;
    const maxAttempts = 30; // 3 seconds total

    function tryLoad() {
      attempts++;
      const container = containerRef.current || document.querySelector(`.ml-embedded[data-form="${formId}"]`);
      if (!container) return;

      // If form is already injected, stop
      if (container.querySelector("form") || container.children.length > 0) {
        return;
      }

      // Check if MailerLite universal script has initialized its callback
      if (window.ml && window.ml.fn && typeof window.ml.fn.renderEmbeddedForm === "function") {
        const scriptId = `ml-jsonp-${formId}`;
        const existingScript = document.getElementById(scriptId);
        if (existingScript) existingScript.remove();

        const script = document.createElement("script");
        script.id = scriptId;
        script.src = `https://assets.mailerlite.com/jsonp/${accountId}/forms/${formId}?callback=ml.fn.renderEmbeddedForm&_t=${Date.now()}`;
        script.async = true;
        document.head.appendChild(script);
        return;
      }

      // If not yet ready, retry shortly
      if (attempts < maxAttempts) {
        timer = setTimeout(tryLoad, 100);
      }
    }

    tryLoad();

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [formId, accountId]);

  return (
    <section className="py-16 sm:py-20 bg-[#0E1017] border-t border-[#181B23]">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
        <div 
          ref={containerRef}
          className="ml-embedded w-full flex justify-center overflow-hidden" 
          data-form={formId} 
        />
      </div>
    </section>
  );
}
